import { c as _c } from "react/compiler-runtime";
import { Button, Field, HStack, Input, Text, VStack } from '@chakra-ui/react';
import { normalizeClarityCodeInput } from '@src/components/sco/Advisors/clarityLink/clarityLinkHelpers';
import { FormEvent } from 'react';
export type ClarityLinkCodeStepProps = {
  /** e.g. `r•••@g•••.com`. The full Clarity email is never sent to the browser. */
  maskedEmail?: string | null;
  code: string;
  onCodeChange: (code: string) => void;
  onVerify: () => void;
  onResend?: () => void;
  verifying?: boolean;
  resending?: boolean;
  verifyLabel?: string;
};

/** Clarity link plan (D2): enter the one-time code emailed to the Clarity account. */
export const ClarityLinkCodeStep = t0 => {
  const $ = _c(32);
  const {
    maskedEmail,
    code,
    onCodeChange,
    onVerify,
    onResend,
    verifying: t1,
    resending: t2,
    verifyLabel: t3
  } = t0;
  const verifying = t1 === undefined ? false : t1;
  const resending = t2 === undefined ? false : t2;
  const verifyLabel = t3 === undefined ? "Verify and link" : t3;
  const ready = code.length === 6;
  let t4;
  if ($[0] !== onVerify || $[1] !== ready || $[2] !== verifying) {
    t4 = event => {
      event.preventDefault();
      if (ready && !verifying) {
        onVerify();
      }
    };
    $[0] = onVerify;
    $[1] = ready;
    $[2] = verifying;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const submit = t4;
  let t5;
  if ($[4] !== maskedEmail) {
    t5 = maskedEmail ? <strong>{maskedEmail}</strong> : "the email on this Clarity account";
    $[4] = maskedEmail;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = <Text color="fg.muted" fontFamily="longform" textStyle="sm">We sent a 6-digit code to{" "}{t5}. It expires in 15 minutes.</Text>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Field.Label>Code from the email</Field.Label>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== onCodeChange) {
    t8 = event_0 => onCodeChange(normalizeClarityCodeInput(event_0.target.value));
    $[9] = onCodeChange;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== code || $[12] !== t8) {
    t9 = <Field.Root>{t7}<Input autoComplete="one-time-code" fontFamily="mono" inputMode="numeric" letterSpacing="0.3em" maxLength={6} placeholder="000000" value={code} width="12rem" onChange={t8} /></Field.Root>;
    $[11] = code;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = !ready;
  let t11;
  if ($[14] !== t10 || $[15] !== verifyLabel || $[16] !== verifying) {
    t11 = <Button disabled={t10} loading={verifying} type="submit" variant="cta">{verifyLabel}</Button>;
    $[14] = t10;
    $[15] = verifyLabel;
    $[16] = verifying;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== onResend || $[19] !== resending || $[20] !== verifying) {
    t12 = onResend ? <Button disabled={verifying} loading={resending} variant="ghost" onClick={onResend}>Send a new code</Button> : null;
    $[18] = onResend;
    $[19] = resending;
    $[20] = verifying;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <HStack gap={3} wrap="wrap">{t11}{t12}</HStack>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t6 || $[27] !== t9) {
    t14 = <VStack align="stretch" gap={3}>{t6}{t9}{t13}</VStack>;
    $[25] = t13;
    $[26] = t6;
    $[27] = t9;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== submit || $[30] !== t14) {
    t15 = <form onSubmit={submit}>{t14}</form>;
    $[29] = submit;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  return t15;
};